<div id="mobileHeader" class="content-wrapper">
  <ab-icon name="logo" color="red" size="24" [routerLink]="['/']"></ab-icon>
</div>
